import _ from 'lodash'

export default navbarMenu

/** @ngInject */
function navbarMenu($state, ApiService, ContractService, ErrorCatcher) {
    return ({
        restrict: 'E',
        template: require('./navbarMenu.jade')(),
        link($scope) {
            $scope.redirectOnClick = () => {
                ApiService.fetchUserInfo().then((userInfo) => {
                    $state.go(ContractService.getMyAccountStatusFromContract(_.get(userInfo, 'contractSelected')))
                }).catch((error) => {
                    if (error.message !== 'transition prevented') {
                        ErrorCatcher.catchError(error)
                    }
                })
            }
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/navbar/navbarMenu.js